import { useGameState } from '@/pages/dsst-shinhan/hooks/useGameState';
import { useViewportMetrics } from '@/pages/dsst-shinhan/hooks/useViewportMetrics';
import TopBar from '@/pages/dsst-shinhan/components/TopBar';
import GuideScreen from '@/pages/dsst-shinhan/components/GuideScreen';
import CountdownScreen from '@/pages/dsst-shinhan/components/CountdownScreen';
import GameScreen from '@/pages/dsst-shinhan/components/GameScreen';
import ResultScreen from '@/pages/dsst-shinhan/components/ResultScreen';
import ExitConfirmModal from '@/pages/dsst-shinhan/components/ExitConfirmModal';

// 신한 SOL 인앱용 기호 맞추기 (DSST) 버전
// 플로우: 게임 소개 → 카운트다운 → 본게임(총 45초 단일 스테이지) → 결과
// 연습 단계/스테이지 구분 없음. 5연속 정답마다 기호 그룹이 교체된다.
export default function DsstShinhan() {
  const metrics = useViewportMetrics();

  const {
    screen,
    symbolMap,
    symbolSetIndex,
    currentSymbol,
    selectedNumber,
    feedback,
    remainingSeconds,
    score,
    totalQuestions,
    correctCount,
    combo,
    setChangeNotice,
    numberOrder,
    showExitModal,
    startGame,
    handleCountdownComplete,
    handleGameSelect,
    goToGuide,
    openExitModal,
    closeExitModal,
    confirmExit,
    retryGame,
    goToNext,
  } = useGameState();

  const isPlaying = screen === 'game';
  const isEntry = screen === 'guide';

  // WebView 네비게이션과 충돌하지 않도록 게임 정보 없이 뒤로/홈만 배치
  const handleBack = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  const handleHome = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  return (
    <div className="shinhan-scope w-full bg-white flex justify-center">
      <div
        className="w-full max-w-[430px] bg-white flex flex-col relative overflow-hidden game-no-scroll"
        style={{ height: `${metrics.height}px` }}
      >
        <TopBar
          onBack={handleBack}
          onHome={handleHome}
          showBack={!isEntry}
          showHome={!isEntry}
        />

        <div className="flex-1 min-h-0 overflow-hidden">
          {screen === 'guide' && (
            <GuideScreen onStart={startGame} setIndex={symbolSetIndex} />
          )}
          {screen === 'countdown' && (
            <CountdownScreen
              onComplete={handleCountdownComplete}
            />
          )}
          {screen === 'game' && (
            <GameScreen
              symbolMap={symbolMap}
              currentSymbol={currentSymbol}
              selectedNumber={selectedNumber}
              feedback={feedback}
              remainingSeconds={remainingSeconds}
              combo={combo}
              setChangeNotice={setChangeNotice}
              setIndex={symbolSetIndex}
              numberOrder={numberOrder}
              onSelect={handleGameSelect}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              totalQuestions={totalQuestions}
              correctCount={correctCount}
              onRetry={retryGame}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}